import { Field } from 'formik';
import { formatPhoneNumber } from '../common';

export default function BasicPracticeSettings({ errors, touched, values, handleBlur, handleChange, setFieldValue, isEditPage }) {
    const handlePhoneNumInput = (e, setFieldValue) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setFieldValue('phoneNo', formattedPhoneNumber);
    };

    const handleEINInput = (e, setFieldValue) => {
        const formattedEIN = formatEIN(e.target.value);
        setFieldValue('entityEin', formattedEIN);
    };

    function formatEIN(value) {
        if (!value) return value;

        const ein = value.replace(/[^\d]/g, '');
        const einLength = ein.length;

        if (einLength < 3) return ein;

        return `${ein.slice(0, 2)}-${ein.slice(2, 9)}`;
    }
    return (
        <div className='space-y-4'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="entityName" className='block text-sm font-medium text-gray-700 mb-1'>Practice Name</label>
                    <div className="mb-3">
                        <Field name="entityName" id="input_entityName" required
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.entityName && touched.entityName ? 'border-red-500' : ''}`}
                            disabled={isEditPage}
                        />
                        {errors.entityName && touched.entityName ? (
                            <div className="text-red-500 text-sm mt-1">{errors.entityName}</div>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label for="entityEin" className='block text-sm font-medium text-gray-700 mb-1'>EIN</label>
                    <div className="mb-3">
                        <Field name="entityEin" id="input_entityEin" required
                            onChange={(e) => handleEINInput(e, setFieldValue)}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.entityEin && touched.entityEin ? 'border-red-500' : ''}`}
                        />
                        {errors.entityEin && touched.entityEin ? (
                            <div className="text-red-500 text-sm mt-1">{errors.entityEin}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="email" className='block text-sm font-medium text-gray-700 mb-1'>Email</label>
                    <div className="mb-3">
                        <Field type="email" id="input_entityEmail" name="entityEmail" required
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.entityEmail && touched.entityEmail ? 'border-red-500' : ''}`}
                            disabled={isEditPage} />
                        {errors.entityEmail && touched.entityEmail ? (
                            <div className="text-red-500 text-sm mt-1">{errors.entityEmail}</div>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label for="phoneNo" className='block text-sm font-medium text-gray-700 mb-1'>Phone Number</label>
                    <div className="mb-3">
                        <Field name="phoneNo" id="input_phoneNo" required
                            onChange={(e) => handlePhoneNumInput(e, setFieldValue)}
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.phoneNo && touched.phoneNo ? 'border-red-500' : ''}`} />
                        {errors.phoneNo && touched.phoneNo ? (
                            <div className="text-red-500 text-sm mt-1">{errors.phoneNo}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="website" className='block text-sm font-medium text-gray-700 mb-1'>Website</label>
                    <div className="mb-3">
                        <Field name="website" id="input_website"
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.website && touched.website ? 'border-red-500' : ''}`} />
                        {errors.website && touched.website ? (
                            <div className="text-red-500 text-sm mt-1">{errors.website}</div>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label for="npi" className='block text-sm font-medium text-gray-700 mb-1'>NPI</label>
                    <div className="mb-3">
                        <Field name="npi" id="input_npi"
                            className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${errors.npi && touched.npi ? 'border-red-500' : ''}`} />
                        {errors.npi && touched.npi ? (
                            <div className="text-red-500 text-sm mt-1">{errors.npi}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}